import { ProblematicStatus, ReferenceType } from "models";

const ORDER_HEALTH_DEFAULT_FILTER = {
  referenceType: ReferenceType.order,
  status: ProblematicStatus.unresolved,
};

export default { ORDER_HEALTH_DEFAULT_FILTER };
